<template>
  <TemplatePageGrid
    :items="workClientAddressGrid"
    :page-data="pageData"
    :loading="loadingAnimation"
    :page_params="{page: 'address_page', limit: 'address_limit'}"
  >
    <template v-slot:buttons>
      <WorkClientAddressModal
        v-if="$userCheckAccess({abilities: 'edit_client_addresses'})"
        create
      />
    </template>
    <WorkClientAddressTable :items="workClientAddressGrid" />
  </TemplatePageGrid>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import WorkClientAddressTable from 'components/workClient/address/WorkClientAddressTable'
import WorkClientAddressModal from 'components/workClient/address/WorkClientAddressModal'

export default {
  name: 'WorkClientAddress',
  components: {
    WorkClientAddressTable,
    WorkClientAddressModal,
  },
  data() {
    return {}
  },
  created() {
    this.downloadPageData()
  },
  watch: {
    '$route.query'() {
      this.downloadPageData()
    },
  },
  computed: {
    ...mapGetters('workClientAddress', ['workClientAddressGrid', 'pageData']),
    ...mapGetters(['loadingAnimation']),
  },
  methods: {
    ...mapActions('workClientAddress', ['onWorkClientAddressGrid']),
    downloadPageData() {
      let data = {
        limit: this.$route.query.address_limit,
        page: this.$route.query.address_page,
        id: this.$route.params.id,
      }
      if (this.$route.query.sort_param && this.$route.query.sort_value) {
        data.sort = {
          param: this.$route.query.sort_param,
          value: this.$route.query.sort_value,
        }
      }
      if (this.$route.query.search) {
        data.search = this.$route.query.search
      }
      this.onWorkClientAddressGrid(data)
    },
  },
}
</script>
